<template>
  <div class="insurance-compliance-addon">
    <div class="addon-head">
      <div>
        <span>HRM_INSURANCE_COMPLIANCE</span>
        <h2>社保公积金合规洞察</h2>
        <p>聚合参保城市规则、员工缴纳配置和缴费状态，识别未参保、基数越界、规则缺口等合规风险。</p>
      </div>
      <el-button type="primary" icon="el-icon-refresh" :loading="loading" @click="loadData">刷新</el-button>
    </div>

    <el-row :gutter="16" class="metric-row">
      <el-col v-for="item in metrics" :key="item.label" :xs="24" :sm="12" :lg="6">
        <div class="metric-card" :class="item.tone">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
          <em>{{ item.meta }}</em>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :xs="24" :lg="14">
        <el-card shadow="never">
          <div slot="header">部门合规风险</div>
          <el-table :data="overview.deptComplianceRisk" size="small" v-loading="loading">
            <el-table-column prop="dept_name" label="部门" min-width="130" />
            <el-table-column prop="active_staff_count" label="在职" width="80" />
            <el-table-column prop="uninsured_count" label="未参保" width="90" />
            <el-table-column prop="unpaid_count" label="未缴纳" width="90" />
            <el-table-column prop="base_out_of_range_count" label="基数异常" width="100" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :lg="10">
        <el-card shadow="never">
          <div slot="header">城市覆盖</div>
          <div class="status-list">
            <div v-for="item in overview.cityCoverage" :key="item.city_name" class="status-item">
              <span>{{ item.city_name }}</span>
              <strong>{{ item.insurance_count }}</strong>
              <em>已缴 {{ item.paid_count || 0 }} / 未缴 {{ item.unpaid_count || 0 }}</em>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="16" class="lower-row">
      <el-col :xs="24" :lg="12">
        <el-card shadow="never">
          <div slot="header">基数越界明细</div>
          <el-table :data="overview.baseOutOfRangeList" size="small" v-loading="loading" empty-text="暂无异常">
            <el-table-column prop="staff_name" label="员工" width="110" />
            <el-table-column prop="dept_name" label="部门" min-width="120" />
            <el-table-column prop="city_name" label="城市" width="90" />
            <el-table-column prop="social_base" label="社保基数" width="100" />
            <el-table-column prop="house_base" label="公积金基数" width="110" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :lg="12">
        <el-card shadow="never">
          <div slot="header">在职未参保员工</div>
          <el-table :data="overview.uninsuredStaffList" size="small" v-loading="loading" empty-text="暂无异常">
            <el-table-column prop="code" label="工号" width="100" />
            <el-table-column prop="staff_name" label="姓名" width="110" />
            <el-table-column prop="dept_name" label="部门" min-width="120" />
            <el-table-column prop="phone" label="电话" width="130" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="lower-row" shadow="never">
      <div slot="header">参保城市规则缺口</div>
      <el-table :data="overview.cityRuleGapList" size="small" v-loading="loading" empty-text="暂无缺口">
        <el-table-column prop="city_name" label="城市" min-width="120" />
        <el-table-column prop="soc_lower_limit" label="社保下限" width="100" />
        <el-table-column prop="soc_upper_limit" label="社保上限" width="100" />
        <el-table-column prop="hou_lower_limit" label="公积金下限" width="110" />
        <el-table-column prop="hou_upper_limit" label="公积金上限" width="110" />
        <el-table-column prop="per_pension_rate" label="养老个人" width="100" />
        <el-table-column prop="com_pension_rate" label="养老企业" width="100" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getInsuranceComplianceOverview } from '../api/insuranceCompliance'

export default {
  name: 'InsuranceComplianceOverview',
  data () {
    return {
      loading: false,
      overview: {
        insuredStaffCount: 0,
        uninsuredActiveStaffCount: 0,
        unpaidInsuranceCount: 0,
        baseOutOfRangeCount: 0,
        missingCityRuleCount: 0,
        cityRuleGapCount: 0,
        deptComplianceRisk: [],
        baseOutOfRangeList: [],
        uninsuredStaffList: [],
        cityCoverage: [],
        cityRuleGapList: []
      }
    }
  },
  computed: {
    metrics () {
      return [
        { label: '已配置参保', value: this.overview.insuredStaffCount, meta: '员工参保记录' },
        { label: '在职未参保', value: this.overview.uninsuredActiveStaffCount, meta: '需补齐配置', tone: 'red' },
        { label: '未缴纳记录', value: this.overview.unpaidInsuranceCount, meta: '缴费状态待处理', tone: 'orange' },
        { label: '基数/规则异常', value: this.overview.baseOutOfRangeCount, meta: `${this.overview.missingCityRuleCount || 0} 条城市缺失`, tone: 'blue' }
      ]
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      getInsuranceComplianceOverview().then(response => {
        if (response.code === 200) {
          this.overview = Object.assign({}, this.overview, response.data || {})
        } else {
          this.$message.warning(response.message || '社保公积金合规洞察加载失败')
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.insurance-compliance-addon {
  padding: 20px;
  background: #f5f7fb;
  min-height: 100%;
}

.addon-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  padding: 22px 24px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 6px;
}

.addon-head span {
  display: block;
  margin-bottom: 8px;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.addon-head h2 {
  margin: 0 0 8px;
  color: #17233d;
  font-size: 24px;
}

.addon-head p {
  margin: 0;
  color: #5f6f89;
}

.metric-row {
  margin-bottom: 16px;
}

.metric-card {
  min-height: 118px;
  padding: 18px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 6px;
}

.metric-card span,
.metric-card em {
  display: block;
  color: #6b7a90;
  font-style: normal;
}

.metric-card strong {
  display: block;
  margin: 10px 0 8px;
  color: #17233d;
  font-size: 30px;
  line-height: 1;
}

.metric-card.red strong {
  color: #d93026;
}

.metric-card.orange strong {
  color: #d9822b;
}

.metric-card.blue strong {
  color: #2f6fec;
}

.lower-row {
  margin-top: 16px;
}

.status-list {
  display: grid;
  gap: 10px;
}

.status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #edf1f7;
  border-radius: 6px;
}

.status-item span,
.status-item em {
  color: #5f6f89;
  font-style: normal;
}

.status-item strong {
  color: #17233d;
  font-size: 16px;
}
</style>
